import React, {Component} from 'react'
import FiltersPartner from './FiltersPartner'
import PartnersTable from './PartnersTable'
import queryString from 'query-string'
import {Pagination} from "antd"
import AddPartner from "./add/AddPartner"
import {listPartner} from "../../../services/api/3dApi"

class PartnersContainer extends Component {
    state = {
        partners: [],
        partnerURL: '',
        loading: false,
        page: 1,
        limit: 50,
        total: 0,
        error: '',
        filters: {
            name: '',
            type: ''
        }
    }

    componentDidMount() {
        this._fetchPartners()
    }

    _fetchPartners = async () => {
        this.setState({
            loading: true
        })

        try {
            const {limit, page, filters} = this.state

            const filterClone = Object.assign({}, filters)

            if (filters.type === '') {
                delete filterClone['type']
            }

            const payload = {
                ...filterClone,
                limit,
                page: page,
                hidden: false
            }
            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)
            const {data, success, error} = response

            if (!success) {
                this.setState({
                    error: error,
                    loading: false
                })
            }

            const {partners, partnerURL, total} = data

            this.setState({
                partners,
                partnerURL,
                total,
                loading: false,
                error: ''
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: current
        }, this._fetchPartners)
    }

    _handlePageChange = (page) => {
        this.setState({
            page: page
        }, this._fetchPartners)
    }

    _handleChangeFilters = (name, value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                [name]: value
            },
            page: 1,
        }, () => {
            this._fetchPartners()
        })
    }

    render() {
        const {loading, partners, partnerURL, page, limit, total, error, filters} = this.state

        return (
            <div className='PartnersContainer'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                            <h3 className='mb-0'>Quản lý Đối tác </h3>
                            <AddPartner/>
                        </div>
                        <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                            <FiltersPartner handleChangeFilters={this._handleChangeFilters} filters={filters}/>
                        </div>
                        <div className="d-flex justify-content-between align-items-center PaginationTop mb-3">
                            <div>{error && <div className="text-danger">{error}</div>}</div>
                            <Pagination current={page} total={total} pageSize={limit}
                                        showTotal={(sum, range) => sum > 0 &&
                                            <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} đối tác`}</strong>
                                            </div>}
                                        onChange={this._handlePageChange}
                                        className='text-right' showSizeChanger
                                        pageSizeOptions={['10', '20', '50', '100']}
                                        onShowSizeChange={this._handleShowSizeChange}/>
                        </div>
                        <div className="PartnersTable">
                            <PartnersTable loading={loading} partners={partners} partnerURL={partnerURL}/>
                        </div>
                        <Pagination current={page} total={total} pageSize={limit}
                                    onChange={this._handlePageChange}
                                    showQuickJumper
                                    className='text-right' showSizeChanger pageSizeOptions={['10', '20', '50', '100']}
                                    onShowSizeChange={this._handleShowSizeChange}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default PartnersContainer
